import React from 'react';
import PropTypes from 'prop-types';

const TextNumber = ({ value }) => {
  
  let displayText = "";
  if (value && value != null){
    displayText = value.toString();
  }
  // if (value < 100) {
  //   displayText = "0" + displayText;
  //   if (value < 10)
  //   {
  //     displayText = "0" + displayText;
  //   }
  // }  
  displayText = displayText.replace(".", ",");

  return (
    <span>{displayText}</span>
  );
};

TextNumber.propTypes = {
  value: PropTypes.number,
};

export default TextNumber;
